import { getAmpConfig } from 'shared/config/amp-config';
import { Asset } from 'shared/api/retail';

import { StaffConfigResponse } from './types';
import { ENTRYWAYS_PROGRAM_BK } from './constants';

const getMClassLink = (link: string) => {
  const isHttpHttpsAbsentPattern = /^(?!https?:\/\/).*/;
  if (isHttpHttpsAbsentPattern.test(link)) {
    return `${getAmpConfig().amplifyMClass}${link}`;
  }

  return link;
};

export const normalizeEntrywaysProgramsAndAppsResponse = (
  data: StaffConfigResponse,
): Asset[] => {
  const dataObj = data.getStaffConfig;
  const entrywaysProgram = {
    businessKey: ENTRYWAYS_PROGRAM_BK,
    name: 'mClass',
    type: 'application',
    metadata: {
      dashboard: {
        appUrl: getMClassLink(dataObj.entrypoint.linkUrl),
        thumbnailUrl: dataObj.entrypoint.asset ?? '',
      },
    },
  };

  return [entrywaysProgram];
};
